import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Stack,
  CircularProgress,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { green } from "@mui/material/colors";

const AddInviteeDialog = ({
  open,
  onClose,
  newInvitee,
  setNewInvitee,
  onAdd,
  arrangements,
  loading,
}) => {
  const handleAdd = () => {
    onAdd();
  };

  const getSideText = (side) => {
    let label;

    switch (side) {
      case "groom":
        label = "新郎";
        break;
      case "bride":
        label = "新婦";
        break;
      case "N":
        label = "未定義";
        break;
      default:
        label = "";
        break;
    }

    return label;
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>新しいゲストを追加</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="呼び名（必須）"
          fullWidth
          required
          value={newInvitee.nick_name}
          onChange={(e) =>
            setNewInvitee({ ...newInvitee, nick_name: e.target.value })
          }
        />

        {/* アレンジメント選択用のセレクトボックスを追加 */}
        <FormControl fullWidth margin="dense">
          <InputLabel>テーブル</InputLabel>

          <Select
            value={newInvitee.arrangement_id || ""}
            onChange={(e) =>
              setNewInvitee({ ...newInvitee, arrangement_id: e.target.value })
            }
            label="アレンジメント"
          >
            {arrangements.map((arrangement) => (
              <MenuItem key={arrangement.id} value={arrangement.id}>
                （{getSideText(arrangement.side)}）
                {arrangement.arrangement_name}
              </MenuItem>
            ))}
            <MenuItem value="">テーブルを割り当てない</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth margin="dense">
          <InputLabel>性別</InputLabel>
          <Select
            value={newInvitee.gender || ""}
            onChange={(e) =>
              setNewInvitee({ ...newInvitee, gender: e.target.value })
            }
            label="性別"
          >
            <MenuItem value="M">男性</MenuItem>
            <MenuItem value="F">女性</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth margin="dense">
          <InputLabel>交通費</InputLabel>
          <Select
            value={newInvitee.travel_cost || ""}
            onChange={(e) =>
              setNewInvitee({ ...newInvitee, travel_cost: e.target.value })
            }
            label="性別"
          >
            <MenuItem value="yes">負担する</MenuItem>
            <MenuItem value="no">負担しない</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        {/* <Button onClick={onClose} color="secondary">キャンセル</Button>
                    <Button onClick={handleAdd} color="primary">追加</Button> */}

        <Stack direction="row" sx={{ mr: 2, mb: 2 }} spacing={1}>
          <Button variant="contained" onClick={onClose} color="secondary">
            キャンセル
          </Button>
          <Box sx={{ position: "relative" }}>
            <Button
              variant="contained"
              onClick={handleAdd}
              disabled={loading}
              color="primary"
            >
              追加
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: green[500],
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default AddInviteeDialog;
